import "./App.css";
import About from "./components/about";
import Card from "./components/cards";
import Carousel from "./components/carousel";
import Header from "./components/header";
import Hero from "./components/hero";
import PROJECTS from './assets/projects/index'
import AttentionDetail from "./components/attention/AttentionDetail";
import Skill from "./components/skills";
import SvgBg from './components/svg-bg'
import Timeline from './components/timeline'
import ParallaxText from './components/parallax'
import Footer from "./components/footer";

import { motion, useScroll, useSpring } from "framer-motion";


function App() {
const { scrollYProgress } = useScroll();
const scaleX = useSpring(scrollYProgress, {
  stiffness: 100,
  damping: 30,
  restDelta: 0.001,
});

  return (
    <div className="Container">
      <motion.div className="progress-bar" style={{ scaleX }} />
      <Header />
      <Hero  />
      <About />
      <Carousel>
        {PROJECTS.map((project) => (
          <Card project={project} />
        ))}
      </Carousel>
      <AttentionDetail />
      <SvgBg>
        <Skill />
      </SvgBg>
      <Timeline />
      <ParallaxText />
      <Footer />
      {/* <div style={{ height: "100vh" }}></div> */}
    </div>
  );
}

export default App;
